import React from "react";
import { Box, Typography } from "@mui/material";
import { useScreenshotTranslation } from "../../../lib/screenshotI18n";
import {
    featurePillSx,
    featurePillsRowSx,
    galleryHeaderAmbientSx,
    galleryHeaderSx,
    galleryHeadlineDarkSx,
    galleryHeadlineSx,
    promoHeadlineLightSx,
    promoHeadlineStackSx,
    promoHeadlineSubtitleLightSx,
    promoHeadlineSubtitleSx,
    promoHeadlineSx,
    promoHeaderCompactLightSx,
    promoHeaderCompactSx,
    promoHeaderLightSx,
    promoHeaderSx,
} from "../styles/screenshotStyles";

function FeaturePill({ icon, label }) {
    return (
        <Box component="span" sx={featurePillSx}>
            <Box component="span" aria-hidden sx={{ fontSize: "0.82rem", lineHeight: 1 }}>
                {icon}
            </Box>
            {label}
        </Box>
    );
}

/** Promo headline + subtitle + optional feature pills (top of screenshot page). */
export default function ScreenshotPromoHeader({
    promoHeadline,
    promoSubtitle,
    variant = "promo",
    showPills = false,
    light = false,
    compact = false,
}) {
    const { t } = useScreenshotTranslation();
    const isVault = variant === "vault";
    const isGallery = variant === "gallery";

    let headerSx = compact ? promoHeaderCompactSx : promoHeaderSx;
    let headlineSx = promoHeadlineSx;
    let subtitleSx = promoHeadlineSubtitleSx;
    if (isGallery) {
        headerSx = galleryHeaderSx;
        headlineSx = galleryHeadlineSx;
        subtitleSx = promoHeadlineSubtitleLightSx;
    } else if (isVault) {
        headerSx = galleryHeaderAmbientSx;
        headlineSx = galleryHeadlineDarkSx;
        subtitleSx = promoHeadlineSubtitleSx;
    } else if (light) {
        headerSx = compact ? promoHeaderCompactLightSx : promoHeaderLightSx;
        headlineSx = promoHeadlineLightSx;
        subtitleSx = promoHeadlineSubtitleLightSx;
    }

    return (
        <Box sx={headerSx}>
            <Box sx={promoHeadlineStackSx}>
                <Typography component="h1" sx={headlineSx}>
                    {promoHeadline}
                </Typography>
                {promoSubtitle && !isGallery ? (
                    <Typography component="p" sx={subtitleSx}>
                        {promoSubtitle}
                    </Typography>
                ) : null}
            </Box>
            {showPills && !isGallery ? (
                <Box sx={featurePillsRowSx}>
                    <FeaturePill icon="💡" label={t("mobileScreenshot.jigsaw.pill-smart-hints")} />
                    <FeaturePill icon="⚡" label={t("mobileScreenshot.jigsaw.pill-smooth-snapping")} />
                </Box>
            ) : null}
        </Box>
    );
}
